import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { headingStyles } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  background: var(--primaryPageThemeColorTint);
  border-radius: 25px;
  overflow: hidden;

  @media ${from(Device.TabletLarge)} {
    position: relative;
    padding: ${fluid(16, 29)} ${fluid(16, 200)} ${fluid(16, 23)} ${fluid(16, 32)};
  }
`;
const Inner = styled.div `
  display: flex;
  flex-direction: column;
`;
const ContentWrapper = styled.div `
  @media ${until(Device.TabletLarge)} {
    padding: 16px;
    padding-bottom: 0;
  }
`;
const Title = styled.h2 `
  ${headingStyles};
  font-size: ${fluid(20, 24)};
  line-height: ${fluid(30, 34)};
  color: var(--titleColor);
  position: relative;
  margin-bottom: ${fluid(18, 26)};
  display: block;
`;
const Summary = styled.p `
  ${fonts.montserrat.light};
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(26, 28)};
  margin-bottom: ${fluid(16, 23)};
`;
const BaseWrapper = styled.div `
  @media ${until(Device.TabletLarge)} {
    position: relative;
    min-height: 180px;
    padding-left: 16px;
    padding-right: 180px;
  }
`;
const Name = styled.span `
  ${fonts.montserrat.regular};
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(26, 28)};
  margin-bottom: 5px;
  display: block;
  color: var(--fgColor);

  &[data-is-link='true'] {
    text-decoration: none;
    color: var(--fgColor);

    &:hover,
    &:focus {
      text-decoration: underline;
      outline: none;
    }
  }
`;
const Role = styled.span `
  ${fonts.montserrat.light};
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(26, 28)};
  opacity: 0.5;
  display: block;
`;
const MediaWrapper = styled.div `
  position: absolute;
  right: 0;
  bottom: 0;
  width: 180px;
  height: 180px;
`;
const Image = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
`;
const SplitAuthorMediaStyles = {
    BaseWrapper,
    Container,
    ContentWrapper,
    Image,
    Inner,
    MediaWrapper,
    Name,
    Role,
    Summary,
    Title,
};
export default SplitAuthorMediaStyles;
